module.exports = __webpack_public_path__ + "assets/792e9bc1ca830749bca9394d9d2300ee.png";